<!-- partial:partial/__subheader.html -->
<breadcrumb #parent>
  <div class="header-absolute"></div>
  <div
    class="sigma_subheader dark-overlay dark-overlay-2 bg-header"
  >
    <div class="container">
      <div class="sigma_subheader-inner section-title">

        <!-- Home -->
        <div *ngIf="breadcrumb === 'home'">
          <div class="sigma_subheader-text text-center">
            <h1 class="bg-header_title">{{ 'header_title' | translate }}</h1>
            <p class="blockquote light">{{ 'header_description' | translate }}</p>
            <a href="https://drive.google.com/file/d/14IrYVhQ-VSLyFZ1xbE09izlC_jpg1F0x/view" target="_blank" class="btn bg-main">
              <span class="mr-2">
                {{ 'header_button' | translate }}
              </span>
                <i
                  class="far"
                  [ngClass]="
                    _translateService.getCurrentLang() === 'ar'
                      ? 'fa-arrow-left'
                      : 'fa-arrow-right'
                  "
                ></i>
            </a>
          </div>
        </div>

        <!-- Item Details (Dynamic title/description) -->
        <div *ngIf="breadcrumb === 'details' && item">
          <div class="sigma_subheader-text">
            <h1> {{ item[_translateService.getCurrentLang() + '_title'] || item[_translateService.getOppositeLang() + '_title'] }}</h1>
            <!-- <p class="blockquote light"> {{ item[_translateService.getCurrentLang() + '_description'] || item[_translateService.getOppositeLang() + '_description'] }} </p> -->
          </div>
        </div>

        <!-- Other routes -->
        <div *ngIf="breadcrumb !== 'home' && breadcrumb !== 'details'">
          <ng-template ngFor let-route [ngForOf]="parent.breadcrumbs">
            <div class="sigma_subheader-text">
              <h1 class="title">{{ route.displayName | translate }}</h1>
              <p class="blockquote light">{{ 'header_description' | translate }}</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</breadcrumb>
<!-- partial -->
